import { staffRoleDescription, type StaffRole } from './staffInviteTypes';

// The key goes after "#": browsers never send the fragment to a server, so it
// stays out of request logs and referrers.
export function buildStaffInviteLink(origin: string, key: string): string {
  return `${origin.replace(/\/+$/, '')}/invite#${key}`;
}

export function buildStaffInviteMailto({
  courseTitle,
  email,
  firstName,
  inviterName,
  link,
  role,
}: {
  courseTitle: string;
  email: string;
  firstName: string;
  inviterName: string;
  link: string;
  role: StaffRole;
}): string {
  const course = courseTitle || 'a course';
  const inviter = inviterName ? `${inviterName} has invited you` : "You've been invited";
  const subject = `Join ${course} on Kudu`;
  const body = [
    `Hi ${firstName},`,
    '',
    `${inviter} to join ${course} on Kudu as ${staffRoleDescription(role)}.`,
    '',
    'Open this link to create your account (or sign in) and join the course:',
    link,
    '',
    'The link works once and expires in 14 days. Please keep it to yourself.',
  ].join('\n');

  return `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
